module.exports = __webpack_public_path__ + "static/media/iphone-nerdify@2x.ebad8e69.png";